import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";

const PrivateRoute = ({ children, allowId }) => {
  const { isAuthenticated, profile } = useContext(AuthContext);

  // not logged in
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // role/id restriction
  if (allowId && profile?.id !== allowId) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
